import { FETCH_LOTTO5_CONFIGS } from "./constant";
import axios from "../axios";
import API_USER from "../../endpoints/user";
import { env } from "../../env";
import { storage, STORAGE_KEYS } from "../../utils/storage";

const notSlot = ["range_line", "odd_even"];
export const configVersion = "allConfig-v6"

const lottoConfig5 = (lottoBetTypes) => {

    const underOver = lottoBetTypes
        .filter((item) => item.type === "under_over" || item.type === "odd_even");
    const ranges = lottoBetTypes
        .filter((item) => item.type === "range");

    return {
        overUnder: underOver,
        ranges: ranges,
    }
}

const lottoConfig6 = (lottoBetTypes) => {
    const rangeLine = lottoBetTypes
        .filter((item) => item.type === "range_line");
    const slots = lottoBetTypes
        .filter((item) => !notSlot.includes(item.type)).map((item) => {
            if (item.code === "UNDER") {
                item.sub = lottoBetTypes.find(e => e.code === "ODD");
            }
            if (item.code === "OVER") {
                item.sub = lottoBetTypes.find(e => e.code === "EVEN");
            }
            return item;
        });

    return {
        rangeLine: rangeLine,
        slots: slots
    }
}
const lottoConfig12 = (lottoBetTypes) => {
    const underOverOddEven = lottoBetTypes?.filter((item) => item.type === "under_over" || item.type === "odd_even");
    const colors = lottoBetTypes?.filter((item) => item.type === "color");
    const numbers = lottoBetTypes?.filter((item) => item.type === "number");
    const range = lottoBetTypes?.filter((item) => item.type === "range");

    return {
        underOverOddEven: underOverOddEven,
        colors: colors,
        numbers: numbers,
        range: range
    }
}

export const fetchLottoConfig = () => (dispatch) => {
    const version = env.VERSION;
    const allConfig = storage.get(STORAGE_KEYS.configAll);
    if (allConfig && allConfig.version === version) {
        dispatch({
            type: FETCH_LOTTO5_CONFIGS,
            payload: allConfig,
        });
        return Promise.resolve(allConfig);
    }

    return axios
        .get(API_USER.FETCH_BETTYPE_CONFIG, {
            params: { oddEven: env.IS_ODD_EVEN === "TRUE" }
        })
        .then((response) => {
            let data = response.data.data;

            let payload = {
                lotto5Config: lottoConfig5(data.lotto5BetTypes),
                lotto6Config: lottoConfig6(data.lotto6BetTypes),
                lotto12Config: lottoConfig12(data.lotto12BetTypes),
                lotto90Config: data.lotto90BetTypes,
                limit: data.limit,
                packagePrices: data.packagePrices,
                lotto90PackagePrices: data.lotto90PackagePrices,
                lotto99PackagePrices: data.lotto99PackagePrices,
                yukiBetTypes: lottoConfig12(data.yukiBetTypes),
                rouletteBetTypes: lottoConfig12(data.rouletteBetTypes),
                version: version
            }


            dispatch({
                type: FETCH_LOTTO5_CONFIGS,
                payload: payload,
            });
            storage.set(STORAGE_KEYS.configAll, payload);
            return response;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};
